__turbopack_context__.v({
  "panel": "Dropdown-module___RXyPW__panel",
  "panelFriKomponent": "Dropdown-module___RXyPW__panelFriKomponent",
});
